import { render, staticRenderFns } from "./fotters.vue?vue&type=template&id=6c8b8c3a&lang=true&"
import script from "./fotters.vue?vue&type=script&lang=js&"
export * from "./fotters.vue?vue&type=script&lang=js&"
import style0 from "./fotters.vue?vue&type=style&index=0&id=6c8b8c3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports